import './App.css';
import LandingInfo from './components/LandingInfo.js'
import Overview from './components/Overview.js';
import Wallet from './components/Wallet.js';
import Roadmap from './components/Roadmap';
import Team from './components/Team';
import Footer from './components/Footer';
import Sale from './components/Sale.js';


function App() {
  return (
    <div>
      <Wallet />
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <LandingInfo />
          </div>
          <div className="col text-light">
            <Sale />
          </div>
        </div>
        <div className="row mt-5">
          <div className="col">
            <Overview />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <Roadmap />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <Team />
          </div>
        </div>
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
}

export default App;
